import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import etherLogo from '../../../assets/images/ether_logo.png';
import { OtpSentProps } from '../../HomePage/types';
import AdminAuthContainer from '../AdminAuthContainer';
import {
  HintText,
  StyledEmail,
  StyledHeader,
  SubHeader,
  SubText
} from '../styled';
import { getFooterLinks } from '../../HomePage/constants/login';
import OtpErrorMessage from '../OtpErrorMessage';
import { useNavigate } from 'react-router-dom';
import '../css/otpInput.css';
import { Link, Typography } from '@mui/material';
import loginAPi from '../../../apis/login';

const AdminOtpScreen = ({
  otp,
  onOtpChange,
  onSubmit,
  errorMessage,
  setErrorMessage,
  email,
  isLoading
}: OtpSentProps) => {
  const navigate = useNavigate();
  const isOtpValid = otp.length === 4;
  const [isLinkDisabled, setIsLinkDisabled] = useState<boolean>(false);
  const [clickCount, setClickCount] = useState<number>(0);
  const isAdminLogin = true;

  const handleResendOtp = async () => {
    setClickCount((prevClickCount) => prevClickCount + 1);
    try {
      await loginAPi.doLogin(email, isAdminLogin);
    } catch (error: any) {
      setErrorMessage('OTP resend failed. Please try again.');
    }
  };

  useEffect(() => {
    setIsLinkDisabled(true);
    const intervalId = setInterval(() => {
      setIsLinkDisabled(false);
    }, 1000 * 60);
    return () => {
      clearInterval(intervalId);
    };
  }, [clickCount]);

  return (
    <AdminAuthContainer
      logoSrc={String(etherLogo)}
      sections={[
        { title: 'OTP Sent!', titleStyle: StyledHeader },
        {
          subtext: (
            <>
              A one-time password (OTP) has been sent to{' '}
              <StyledEmail>{email}</StyledEmail>. Please check your inbox and
              enter the OTP below to log in to Ether.
            </>
          ),
          subtextStyle: SubText
        },
        { title: 'Verify With OTP', titleStyle: SubHeader },
        {
          subtext: <HintText>Enter 4 digit OTP here</HintText>,
          subtextStyle: SubText
        }
      ]}
      buttonText='Login to Ether'
      onSubmit={onSubmit}
      footerText='By proceeding, I agree to the '
      footerLinks={getFooterLinks(navigate)}
      isLoading={isLoading}
      isButtonDisabled={!isOtpValid}
    >
      <OtpInput
        value={otp}
        onChange={onOtpChange}
        numInputs={4}
        renderInput={(props) => (
          <input
            {...props}
            className={`otp-input ${errorMessage ? 'error' : ''}`}
          />
        )}
        inputType='tel'
        shouldAutoFocus
        inputStyle='otp-input'
      />
      <Typography variant='caption' color='textSecondary'>
        {isLinkDisabled ? (
          'Click here to resend otp'
        ) : (
          <Link
            component='span'
            onClick={handleResendOtp}
            sx={{ cursor: 'pointer' }}
          >
            Click here to resend otp
          </Link>
        )}
      </Typography>
      {errorMessage && <OtpErrorMessage errorMessage={errorMessage} />}
    </AdminAuthContainer>
  );
};

export default AdminOtpScreen;
